<script setup lang="ts">
import type { ProductLineDetail, ProductSet } from '~/types/api'

const localePath = useLocalePath()
const props = defineProps<{
  line: ProductLineDetail | null
  set: ProductSet | null
}>()
</script>

<template>
  <div class="mt-60 grid bg-neutral-100 lg:grid-cols-2">
    <div class="relative">
      <NuxtImg
        class="absolute -top-60 right-0 h-[500px]"
        sizes="400px sm:700px"
        :src="withHost(props.set?.images?.at(0)?.url)"
      />
      <div class="mx-auto mt-60 max-w-xl p-10 lg:mt-52">
        <h1
          class="font-pragmatica-ext ml-10 w-min gap-4 text-5xl font-bold first-letter:-ml-10 md:ml-16 md:first-letter:-ml-16 lg:text-6xl 2xl:text-8xl"
        >
          {{ props.line?.title }}
        </h1>
        <div v-html="props.line?.description" class="max-w-2xl py-5"></div>
        <NuxtLink
          :to="
            localePath({
              name: 'slug',
              params: { slug: props.line?.urlSlug },
            })
          "
        >
          <UiButtonBlack>
            {{ $t('productline.footer.cta') }}
          </UiButtonBlack>
        </NuxtLink>
      </div>
    </div>
    <div>
      <NuxtImg
        class="h-full max-h-[60svh] w-full object-cover object-bottom"
        sizes="400px sm:700px md:850px lg:1000px xl:1500px"
        :src="withHost(props.line?.backgroundImages?.at(0)?.url)"
      />
    </div>
  </div>
</template>
